import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-progressbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'progressbar.component.html',
})
export class ProgressbarComponent {
  @Input() progress = 0;
  @Input() progressFormatted = '';
  @Input() color: 'green' | 'red' | 'blue' | 'orange' | 'yellow' = 'green';
  @Input() showPercentage = true;
}
